import { render, staticRenderFns } from "./Routes.vue?vue&type=template&id=e985cf1c&scoped=true&"
import script from "./Routes.vue?vue&type=script&lang=js&"
export * from "./Routes.vue?vue&type=script&lang=js&"
import style0 from "./Routes.vue?vue&type=style&index=0&id=e985cf1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e985cf1c",
  null
  
)

export default component.exports